import {ActionFunctionParameters} from '../StructuredTableConstants';

/**
 * Function to be passed as renderOverflowMenuItem to makeCustomButtonActionFunction if the action
 * function doesn't support being rendered in the overflow menu.
 */
export default function unsupportedOverflowMenuItem<TTableMetadata, TRowMetadata>(
  params: ActionFunctionParameters<TTableMetadata, TRowMetadata>
): never {
  throw new Error('Not implemented');
}
